import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <span className="text-xl font-bold text-primary-500 tracking-tight">
              韩漫网站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {comicCategories.slice(0, 6).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <button
              onClick={() => handleCategoryClick('all')}
              className="px-3 py-2 text-sm rounded-lg text-foreground-700 hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              更多
            </button>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              关于我们
            </Link>
            <button className="px-4 py-2 bg-primary-500 text-white text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer font-medium">
              开始阅读
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer rounded-lg hover:bg-background-100 transition-colors"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-fade-in-up">
          <div className="px-4 py-3 space-y-1">
            {comicCategories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`block w-full text-left px-3 py-2.5 rounded-lg text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <hr className="border-background-200 my-2" />
            <Link
              to="/about"
              className="block px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}